import React from 'react';
import fox from '../../resources/fox_audit.png';
import bf_fox from '../../resources/bf_fox_audit.png';
import Echo from "laravel-echo"


import ctrans from "../trans"
import {
  Div,
  Header as H,
  TextInput,
  Icon,
  css,
  Button,
  Grid,
  GridCell,
  Spinner,

} from "@bdfx/fukit"
import { getAuditId } from '../helpers';
import {apiGetAudit} from "@bdfx/audit-api"

interface Props {
  auditId: string
  email: string
}

interface State {
  progress: number
  data: any
  error: boolean | string
}

const w: any = window
w.io = require('socket.io-client');

export const echo = w.Echo = new Echo({
    broadcaster: 'socket.io',
    host: 'https://ws.audit.bdfx.cz',
    namespace: '',
    transports: ["websocket"],
})


class ModalProgress extends React.PureComponent<Props, State> {
  private listening = false
  private check = null

  state = {
    progress: 0,
    data: null,
    error: false,
  }

  auditFinished = (e) => { this.setState({ data: e, progress: 7 }); }
  auditUpdated = (e) => { this.setState({ data: e }) }
  auditFailed = (e) => { this.setState({ error: e.error ?? true }) }

  componentDidMount() {
      const w:any = window
      if (typeof w.io !== 'undefined') {
          if(this.listening === false) {
            this.listening = true
            echo.channel('audit.'+ this.props.auditId)
                        .listen('.audit.finished', this.auditFinished)
                        .listen('.audit.updated', this.auditUpdated)
                        .listen('.audit.failed', this.auditFailed)
          }
      }

      if(!this.check) {
        this.check = setInterval(() => {
          apiGetAudit(this.props.auditId).then(e => this.setState({ data: e.data?.data, error: e.data?.data?.error }))
        }, 5000)
      }
  }

  componentWillUnmount() {
    clearInterval(this.check)
  }

    renderIcon = (s) => {
      const {data, error} = this.state
      if(error) {
        return <Icon type="close" color="red" />
      }
      if(data?.progress?.[s] === 100) {
        return <Icon type="check-square" color="green" />
      } else if(data?.progress?.[s] > 0) {
        return <Spinner size={15} />
      } else {
        return <Icon type="hourglass-o" color="#ccc" />
      }
    }

    copyToClipboard = () => {
        /* Get the text field */
        var copyText: any = document.getElementById("audit-address");

        /* Select the text field */
        copyText.select();
        copyText.setSelectionRange(0, 99999); /* For mobile devices */

        /* Copy the text inside the text field */
        document.execCommand("copy");

    }

    render() {
      const { progress, data, error } = this.state
      const { email } = this.props
      return (
        <Style>
          <H type={2}>{ctrans("progress_step2_header")}</H>
          <p>
            {progress > 6 ? 
            <Grid cols="300px 1fr" align="right">
              <Div maxWidth="300px">
                {ctrans("result_url_label")}: <br/>
                
                <Grid cols="1fr 1fr" gap="20px">
                  <GridCell col="1 / -1">
                    <TextInput id={"audit-address"} readonly={true} value={`https://${data.type}-audit.${data.locale}/audit/${data.id}`} />
                  </GridCell>
                  <Div whiteSpace="nowrap" className="buttons">
                  <Button color="green" icon="copy-light" onClick={this.copyToClipboard}>{ctrans("copy")}</Button> &nbsp;
                  <Button color="green" onClick={(e) => {e.preventDefault(); e.stopPropagation(); window.open(`https://${data.type}-audit.${data.locale}/audit/${data.id}`); return false; }} rel={"noopener"} icon="sticker-light">{ctrans("open")}</Button>
                  </Div>
                </Grid>
              </Div>
              <Div float="right" marginBottom="-150px" marginRight="-20px" position="relative" zIndex="1">
                {process.env.APP === "bidding" ?
                <img width="250" height="229" src={bf_fox} alt="Lišák Fox audituje" />
                :
                <img width="243" height="305" src={fox} alt="Lišák Fox audituje" />
              }
              </Div>
            </Grid>
        
            : <>
              <p style={{ opacity: error ? 0.2 : 1 }}>
              {ctrans("progress_info")}:&nbsp;<a href={`mailto:${email}`} rel={"nofollow"}>{email}</a>
              </p>
              {ctrans("progress_steps")}:
              <Grid cols="1fr auto" gap="5px" style={{ margin: "10px", fontSize: "0.9em", }}>
                <span>1. {ctrans("progress_step1")}</span>
                {this.renderIcon("stage_downloading_percent")}
                <span>2. {ctrans("progress_step2")}</span>
                {this.renderIcon("stage_importing_percent")}
                <span>3. {ctrans("progress_step3")}</span>
                {this.renderIcon("stage_scraping_percent")}
                <span>4. {ctrans("progress_step4")}</span>
                {this.renderIcon("stage_processing_percent")}
                <span>5. {ctrans("progress_step5")}</span >
                {this.renderIcon("stage_finishing_percent")}
              </Grid>
              {error ?
              <Div padding="20px 0" fontWeight="bold">
                  <Icon type="exclamation-triangle" color="red">
                    {typeof error === "string" ? ctrans("error_"+error, { mail: process.env.APP === "pricing" ? <a href={`mailto:podpora@pricingfox.cz`}>podpora@pricingfox.cz</a> : <a href={`mailto:podpora@biddingfox.com`}>podpora@biddingfox.com</a> }) : ctrans("unknown_error")}
                  </Icon><br/><br/>
                {error && typeof error === "string" && `${error}`.indexOf('404') === -1 ? 
                  <Button color="red" size="tiny" icon="repeat" secondary={true} onClick={() => {window.location.href = `/audit/${data?.id ?? getAuditId()}/regenerate`}}>Zkusit znovu</Button>
                  : null }
              </Div>
              : null
              }
              
            </>}
            {progress > 6 ? null : 
            <Grid cols="50px 1fr" className={`tip ${process.env.APP}`} >
              <Icon type="lightbulb-light" color="yellow" size={50} />
              <p>
                {process.env.APP === "pricing" ? ctrans("other_audits_links_pricing") : ctrans("other_audits_links_bidding")} 
              </p>
            </Grid>           
            }
          </p>

        </Style>
               
        )
    }

}

const Style = css("div")({
  ".tip": {
    marginTop: "40px",
    paddingTop: "10px",
    borderTop: "1px solid #eee",
    marginBottom: "-20px",
    "&.pricing a ": {
      color: "#729A3C",
    },
    "&.bidding a ": {
      color: "#009ba9",
    },
  }
})

export default ModalProgress
